import type { RecurringPayment, RecurringPaymentKind, RecurringPaymentStatus } from '@/lib/api';

export type RecurringPaymentAction = 'confirm' | 'reject' | 'cancel' | 'reactivate';

export function statusForRecurringPaymentAction(
  action: RecurringPaymentAction,
): {
  status: RecurringPaymentStatus;
  userConfirmed?: boolean;
  kind?: RecurringPaymentKind;
} {
  switch (action) {
    case 'confirm':
      return { status: 'Active', userConfirmed: true };
    case 'reject':
      return { status: 'Rejected', userConfirmed: false };
    case 'cancel':
      return { status: 'Cancelled', userConfirmed: true };
    case 'reactivate':
      return { status: 'Active', userConfirmed: true };
  }
}

export function canDeleteRecurringPayment(item: Pick<RecurringPayment, 'kind'>): boolean {
  return item.kind !== 'Installment';
}
